import DeliveryList from "./DeliveryList";

export default DeliveryList;
